import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Menus, Text } from '@Sage/hoi-poi-ui';
import { ThreeDots } from 'components/SvgIcons';
import { CFM_STONE } from 'constants/Colors';
import Literal from 'components/literal';

const SecondaryActionButtons = ({ data }) => {
    const items = useMemo(
        () =>
            data.map((el) => ({
                title: (
                    <Text className="secondary-action-btn__text">
                        <Literal literal={el.label} />
                    </Text>
                ),
                icon: el.icon,
                onClick: el.action,
                className:
                    el.customClassName ||
                    `${el.className} secondary-action-btn${
                        el.color ? ` secondary-action-btn--${el.color}` : ''
                    }`,
            })),
        [data],
    );

    return (
        data.length > 0 && (
            <Menus
                className="action-buttons__secondaries"
                classNameMenu="action-buttons__secondaries__menu"
                icon={<ThreeDots color={CFM_STONE} />}
                items={items}
            />
        )
    );
};

SecondaryActionButtons.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            action: PropTypes.func,
            icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
            label: PropTypes.string,
            principal: PropTypes.bool,
        }),
    ).isRequired,
};

export default memo(SecondaryActionButtons);
